import { Component, input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-oauth',
  templateUrl: './userapi-oauth.component.html'
})
export class UserApiOAuthComponent extends AbstractUserApiModalComponent {
  readonly userApi = input<UserAPI>();
}
